import { pages, subPackages } from '@/pages.json'
import { envConfig } from './env'

export function getLastPage() {
  // getCurrentPages() 至少有1个元素，所以不再额外判断
  // const lastPage = getCurrentPages().at(-1)
  // 上面那个在低版本安卓中打包会报错，所以改用下面这个【虽然我加了 src/interceptions/prototype.ts，但依然报错】
  const pages = getCurrentPages()
  return pages[pages.length - 1]
}

/**
 * 获取当前页面路由的 path 路径和 redirectPath 路径
 * path 如 '/pages/loginChoseType/index'
 * redirectPath 如 '/pages/demo/base/route-interceptor'
 */
export function currRoute() {
  const lastPage = getLastPage()
  const currRoute = (lastPage as any).$page
  // console.log('lastPage.$page:', currRoute)
  // console.log('lastPage.$page.fullpath:', currRoute.fullPath)
  // console.log('lastPage.$page.options:', currRoute.options)
  // console.log('lastPage.options:', (lastPage as any).options)
  // 经过多端测试，只有 fullPath 靠谱，其他都不靠谱
  const { fullPath } = currRoute as { fullPath: string }
  // console.log(fullPath)
  // eg: /pages/loginChoseType/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor (小程序)
  // eg: /pages/loginChoseType/index?redirect=%2Fpages%2Froute-interceptor%2Findex%3Fname%3Dfeige%26age%3D30(h5)
  return getUrlObj(fullPath)
}

function ensureDecodeURIComponent(url: string) {
  if (url.startsWith('%')) {
    return ensureDecodeURIComponent(decodeURIComponent(url))
  }
  return url
}
/**
 * 解析 url 得到 path 和 query
 * 比如输入url: /pages/loginChoseType/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor
 * 输出: {path: /pages/loginChoseType/index, query: {redirect: /pages/demo/base/route-interceptor}}
 */
export function getUrlObj(url: string) {
  const [path, queryStr] = url.split('?')
  // console.log(path, queryStr)

  if (!queryStr) {
    return {
      path,
      query: {},
    }
  }
  const query: Record<string, string> = {}
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    // console.log(key, value)
    query[key] = ensureDecodeURIComponent(value) // 这里需要统一 decodeURIComponent 一下，可以兼容h5和微信y
  })
  return { path, query }
}
/**
 * 得到所有的需要登录的 pages，包括主包和分包的
 * 这里设计得通用一点，可以传递 key 作为判断依据，默认是 needLogin, 与 route-block 配对使用
 * 如果没有传 key，则表示所有的 pages，如果传递了 key, 则表示通过 key 过滤
 */
export function getAllPages(key = 'needLogin') {
  // 这里处理主包
  const mainPages = pages
    .filter(page => !key || page[key])
    .map(page => ({
      ...page,
      path: `/${page.path}`,
    }))

  // 这里处理分包
  const subPages: any[] = []
  subPackages.forEach((subPageObj) => {
    // console.log(subPageObj)
    const { root } = subPageObj

    subPageObj.pages
      .filter(page => !key || page[key])
      .forEach((page: { path: string } & Record<string, any>) => {
        subPages.push({
          ...page,
          path: `/${root}/${page.path}`,
        })
      })
  })
  const result = [...mainPages, ...subPages]
  // console.log(`getAllPages by ${key} result: `, result)
  return result
}

/**
 * 得到所有的需要登录的 pages，包括主包和分包的
 * 只得到 path 数组
 */
export const getNeedLoginPages = (): string[] => getAllPages('needLogin').map(page => page.path)

/**
 * 得到所有的需要登录的 pages，包括主包和分包的
 * 只得到 path 数组
 */
export const needLoginPages: string[] = getAllPages('needLogin').map(page => page.path)

/**
 * 得到所有不需要登录的 pages，包括主包和分包的
 * 只得到 path 数组
 */
export const getNeedNotLoginPages = (): string[] => getAllPages('needNotLogin').map(page => page.path)

/**
 * 得到所有不需要登录的 pages，包括主包和分包的
 * 只得到 path 数组
 */
export const needNotLoginPages: string[] = getAllPages('needNotLogin').map(page => page.path)

/** 获取当前 mode 对应的请求地址 */
export function getEnvBaseUrl() {
  return {
    baseUrl: envConfig.serverBaseUrl,
    authBaseUrl: envConfig.authRequestBaseUrl,
  }
}

/** 获取当前 mode 对应的上传地址 */
export function getEnvBaseUploadUrl() {
  return envConfig.uploadBaseUrl
}

/**
 * 解析查询字符串为键值对对象
 */
export function parseToKeyValue(str) {
  // 初始化空对象
  const result = {}

  // 处理空值/非字符串情况
  if (!str || typeof str !== 'string')
    return result

  // 1. 按?拆分所有键值对
  str.split('?').forEach((pair) => {
    // 跳过空项（如字符串首尾有?的情况）
    if (!pair)
      return

    // 2. 按第一个=拆分键和值（保留value原始格式）
    const equalIndex = pair.indexOf('=')
    if (equalIndex === -1)
      return // 无=的项跳过

    const key = pair.slice(0, equalIndex)
    const value = pair.slice(equalIndex + 1)

    // 3. 组装键值对（key非空才添加）
    if (key) {
      result[key] = value
    }
  })

  return result
}
